import React, { useState } from 'react';

const CuatroColumn = ({ row }) => {
  const [expanded, setExpanded] = useState(false);

  let formattedJson;
  try {
    const parsedJson = JSON.parse(row.original.cuatro); // Analiza el JSON en cadena
    formattedJson = JSON.stringify(parsedJson, null, 2); // Formatea el JSON con 2 espacios de indentación
  } catch (error) {
    formattedJson = 'Invalid JSON'; // Maneja errores de análisis
  }

  const isLarge = formattedJson.length > 300; // Verifica si el JSON formateado es grande (umbral de 300 caracteres)

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <pre style={{ whiteSpace: 'pre-wrap', maxHeight: expanded || !isLarge ? 'none' : '100px', overflow: 'hidden' }}>
        {formattedJson}
      </pre>
      {isLarge && (
        <span onClick={handleToggle} style={{ color: 'blue', cursor: 'pointer' }}>
          {expanded ? 'Mostrar menos' : 'Mostrar más'}
        </span>
      )}
    </div>
  );
};

export default CuatroColumn;
